import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import fetch from 'isomorphic-fetch'

import { isAnyPartOfElementInViewport } from '../../actions/actions'
import { guessVars } from '../../actions/states/new/setupVars'
import { getSortedWebinars, guessLatestFromProps } from '../../actions/states/webinars'

const LandingContent = props => {
  const [listenerComplete, setListenerComplete] = useState(false)
  const params = useParams()
  const variableArray = guessVars(params.state)
  const qsParam = variableArray?.siteId ? `?regionId=${variableArray.siteId}` : ''
  const { data } = useQuery(['latest-webinars', qsParam], () => {
    return fetch(`/api/v2/marketing/webinars${qsParam}`, {
      method: 'GET'
    }).then(resp => resp.json())
  })
  const upcomingWebinar = data?.upcoming

  console.log('found upcoming', upcomingWebinar)

  useEffect(() => {
    handleScroll(null)
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const handleScroll = event => {
    if (listenerComplete) {
      return
    }

    const itms = document.querySelectorAll('.home-section:not(.has-been-viewed)')

    if (itms.length <= 0) {
      setListenerComplete(true)

      return
    }

    itms.forEach(selectedEle => {
      //console.log(selectedEle, this.isAnyPartOfElementInViewport(selectedEle))
      if (isAnyPartOfElementInViewport(selectedEle)) {
        selectedEle.classList.add('has-been-viewed')
      }
    })
  }

  console.log(upcomingWebinar)

  return (
    <div id="nocontent">
      <div id="marketsite" className={variableArray.siteId || 'arkansas'}>
        <div className={`customer-subpage`}>
          <div className="container-fluid">
            <div className="row">
              <div>
                <div className="ce-container text-right" style={{ height: '25px' }}></div>

                <div className="container top-header-well">
                  {upcomingWebinar ? (
                    <div className="alert alert-warning">
                      {upcomingWebinar.webinarDetails}.<br />
                      <Link
                        className="btn btn-primary pull-right"
                        to={`${variableArray.pathPrefix}/webinar`}>
                        Find out more and sign up
                      </Link>
                      <br className="clear" />
                    </div>
                  ) : null}
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <h2>{variableArray.headerTitle}</h2>
                      <p style={{ marginTop: '25px', marginBottom: '25px' }}>
                        {variableArray.headerTitleDescription}
                      </p>
                      <br />
                    </div>
                    <div className="col-sm-6 hidden-xs flex-right">
                      <img
                        className="img-responsive"
                        style={{ marginBottom: '0', marginTop: '-27px' }}
                        src={variableArray.topScreenshotUrl}
                      />
                    </div>
                  </div>
                </div>
                <div className="home-section home-section-features">
                  <div className="container">
                    <h3 className="text-center">{variableArray.featuresTitle}</h3>
                    <ul className="nocheck featurelist">
                      {variableArray.features.map(f => (
                        <li className={f.cssClass}>{f.title}</li>
                      ))}
                    </ul>
                    <br style={{ clear: 'both' }} />
                  </div>
                </div>
                <div className="home-section home-section-upgrade">
                  <div className="container">
                    <h3 className="text-center">{variableArray.upgradeTitle}</h3>
                    <div className="col-md-6">
                      <img
                        className="pull-left upgrade-pic"
                        src="/images/www/new/homepage/Homepage-SingleEducator.svg"
                      />
                      <div className="upgrade-content">
                        <h4>Single Educator</h4>
                        <p>
                          Ideal for educators who want to use Headed2 in their classroom,
                          as well as students and jobseekers.
                        </p>
                        <Link
                          to={`${variableArray.pathPrefix}/pricing/individual`}
                          className="btn btn-success btn-full">
                          View Options
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <img
                        className="pull-left upgrade-pic"
                        src="/images/www/new/homepage/Homepage-MultipleEducator.svg"
                      />
                      <div className="upgrade-content">
                        <h4>Multiple Educators</h4>
                        <p>
                          Ideal for groups, organizations, schools, or districts who want
                          to want to collaborate with a more locally relevant, custom
                          experience.
                        </p>
                        <Link
                          to={`${variableArray.pathPrefix}/pricing/group`}
                          className="btn btn-success btn-full">
                          View Options
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="container" style={{ marginTop: '35px' }}>
                    <div className="text-right">
                      Already have an account?{' '}
                      <a href={variableArray.appUrl}>Go there now</a>.
                    </div>
                  </div>
                </div>
                <div className="home-section home-section-sponsor">
                  <div className="container">
                    <div className="row">
                      <div
                        className={variableArray.sponsorImg ? 'col-xs-9' : 'col-xs-12'}>
                        <h3>{variableArray.sponsorMsg}</h3>
                      </div>
                      <div className={variableArray.sponsorImg ? 'col-xs-3' : ''}>
                        {variableArray.sponsorImg && (
                          <img
                            src={variableArray.sponsorImg}
                            alt="Sponsor Logo"
                            className="sponsor-img img-responsive"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="home-section home-section-exploration">
                  <div className="feature-detail">
                    <h2>{variableArray.menuHeader}</h2>
                  </div>
                  <div className="container cloud-bg">
                    <img
                      src="/images/www/new/homepage/Homepage-CareerExploration-Illustration.svg"
                      className="main-content-img image-grow align-right"
                    />
                    <div className="main-content-left-container">
                      <h3>
                        Innovative <b>career exploration</b> and <b>planning</b>
                      </h3>
                      <ul>
                        <li>
                          Take an assessment to see what you might be interested in doing
                        </li>
                        <li>
                          Develop a budget to make sure that your choices can support you
                        </li>
                        <li>Make a plan to support your decisions</li>
                      </ul>
                      <Link
                        to={`${variableArray.pathPrefix}/plan`}
                        className="btn btn-success btn-lg">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="home-section">
                  <div className="container">
                    <img
                      src="/images/www/new/homepage/Homepage-WBL-Illustration.svg"
                      className="main-content-img image-grow align-left"
                    />
                    <div className="main-content-right-container">
                      <h3>
                        State of the art <b>solutions</b> for <b>work based learning</b>
                      </h3>
                      <ul>
                        <li>Make representatives available to classes</li>
                        <li>Give company tours to students</li>
                        <li>Offer internships</li>
                      </ul>
                      <Link
                        to={`${variableArray.pathPrefix}/localopportunities`}
                        className="btn btn-success btn-lg">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="home-section home-section-utl">
                  <div className="title-wrap-content-utl">
                    <div className="container">
                      <h3>
                        Bringing <b>career exploration</b> to <b>younger students</b>
                      </h3>
                    </div>
                  </div>
                  <div className="main-content-utl">
                    <div className="container">
                      <img
                        src="/images/www/new/homepage/UTL-Logo.svg"
                        className="utl-image image-grow"
                      />
                      <ul>
                        <li>Familiar Gameboard Style Presentation</li>
                        <li>Personalized Avatar and Backpack</li>
                        <li>Badges and Levels to Track Progress</li>
                        <li>Highly Visual with Simplified Language</li>
                      </ul>
                      <br style={{ clear: 'left' }} />
                      <Link
                        to={`${variableArray.pathPrefix}/uptheladder`}
                        className="btn btn-success btn-lg btn-invert">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="home-section feature-contact-section">
                  <div className="container" style={{ paddingBottom: '10px' }}>
                    <div className="col-sm-6">
                      <div className="title-wrap webinar">
                        <h4>Watch our webinars</h4>
                        <p>
                          Sign-Up for our upcoming webinars, or watch previous recordings
                        </p>
                      </div>
                      <img
                        src="/images/www/new/homepage/Homepage-WebinarVideo.svg"
                        className="img-responsive"
                      />
                      <Link
                        to={
                          upcomingWebinar?.webinarSignupForm
                            ? `${variableArray.pathPrefix}/webinar`
                            : `${variableArray.pathPrefix}/webinar/latest`
                        }
                        className="btn btn-success btn-full">
                        {upcomingWebinar?.webinarSignupForm
                          ? `Sign Up`
                          : `Start Watching`}
                      </Link>
                    </div>
                    <div className="col-sm-6">
                      <div className="title-wrap brochure">
                        <h4>Download brochure</h4>
                        <p>
                          Get our printable PDF to forward to a colleague or browse at a
                          later date
                        </p>
                      </div>
                      <img
                        src={variableArray.brochureDownloadImg}
                        className="img-responsive"
                      />
                      <a
                        href={variableArray.brochureDownloadUrl || '#'}
                        className="btn btn-success btn-full">
                        Download
                      </a>
                    </div>
                  </div>
                </div>
                <div className="home-section contact-banners">
                  <div className="container">
                    <div
                      className="row"
                      style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                      <div className="col-sm-7">
                        <h3 style={{ marginBottom: '25px' }}>
                          About <b>Headed2</b> and the <b>CareerExplorer</b>
                        </h3>
                        <p>
                          For over 15 years, Headed2 has been helping students plan for
                          their future and explore the world of work. In that time, we
                          have grown into a reliable and robust platform that services
                          millions of individuals each year from across the United States.
                        </p>
                        <Link
                          to={`${variableArray.pathPrefix}/about`}
                          className="btn btn-success btn-lg">
                          Learn More
                        </Link>
                      </div>
                      <div className="col-sm-offset-1 col-sm-4">
                        <h3 style={{ marginBottom: '25px' }}>
                          <b>Where</b> else is the <b>CareerExplorer?</b>
                        </h3>

                        {variableArray.otherSites.map(s => (
                          <div key={s.logoSrc}>
                            <a href={'#'}>
                              <img className="img-responsive logo-size" src={s.logoSrc} />
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingContent
